var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10Message(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10. Message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Message",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001,2 C7.02951,2 3.00008,6.02944 3.00008,11 C3.00008,12.7263 3.48511,14.3362 4.32583,15.7044 L4.59701,16.1457 L2.90402,20.0961 L6.85434,18.4031 L7.29567,18.6742 C8.66389,19.515 10.2738,20 12.0001,20 C16.9706,20 21.0001,15.9706 21.0001,11 C21.0001,6.02944 16.9706,2 12.0001,2 Z M1.00008,11 C1.00008,4.92487 5.92494,0 12.0001,0 C18.0752,0 23.0001,4.92487 23.0001,11 C23.0001,17.0751 18.0752,22 12.0001,22 C10.0818,22 8.2759,21.5082 6.70417,20.6434 L3.69186,21.9343 C2.03242,22.6455 0.354534,20.9677 1.06573,19.3082 L2.35672,16.2959 C1.49191,14.7242 1.00008,12.9183 1.00008,11 Z M7.00008,9 C7.00008,8.44772 7.44779,8 8.00008,8 L11.0001,8 C11.5524,8 12.0001,8.44772 12.0001,9 C12.0001,9.5523 11.5524,10 11.0001,10 L8.00008,10 C7.44779,10 7.00008,9.5523 7.00008,9 Z M7.00008,13 C7.00008,12.4477 7.44779,12 8.00008,12 L16.0001,12 C16.5524,12 17.0001,12.4477 17.0001,13 C17.0001,13.5523 16.5524,14 16.0001,14 L8.00008,14 C7.44779,14 7.00008,13.5523 7.00008,13 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Message);
export default __webpack_public_path__ + "static/media/10. Message.4040fe3065b5dd3c4cac130c059dc105.svg";
export { ForwardRef as ReactComponent };